import agendaApiConfig from "../../services/agenda/agendaApiConfig";
import _raw from "../../shared/templates/email-familygroup.txt";

const ORIGIN = "CASC";

export const FamilyService = {
  async getPatient(pac_correl, origin) {
    return await agendaApiConfig.get(`/parentesco/v2/paciente`, {
      baseURL: process.env.REACT_APP_API_BASE,
      headers: {
        "X-Origin": origin,
      },
      params: {
        pac_correl: pac_correl,
      },
    });
  },
  async getFamilyGroup(rut) {
    return {
      data: [],
    };

    return await agendaApiConfig.get(`/parentesco/v2/grupo`, {
      baseURL: process.env.REACT_APP_API_BASE,
      headers: {
        "X-Origin": ORIGIN,
      },
      params: {
        rut: rut,
      },
    });
  },
  async getTutor(rut) {
    return await agendaApiConfig.get(`/parentesco/v2/tutor`, {
      baseURL: process.env.REACT_APP_API_BASE,
      headers: {
        "X-Origin": ORIGIN,
      },
      params: {
        rut: rut,
      },
    });
  },
  async addFamilyMember(body) {
    return await agendaApiConfig.post(`/parentesco/v2/agregar`, body, {
      baseURL: process.env.REACT_APP_API_BASE,
      headers: {
        "X-Origin": ORIGIN,
      },
    });
  },
  async confirmFamilyMember(body) {
    return await agendaApiConfig.post(`/parentesco/v2/confirmar`, body, {
      baseURL: process.env.REACT_APP_API_BASE,
      headers: {
        "X-Origin": ORIGIN,
      },
    });
  },
  async removeFamilyMember(body) {
    return await agendaApiConfig.post(`/parentesco/v2/desvincular`, body, {
      baseURL: process.env.REACT_APP_API_BASE,
      headers: {
        "X-Origin": ORIGIN,
      },
    });
  },
  async getTiposParentesco() {
    return await agendaApiConfig.get(`/parentesco/v2/tipo_parentesco`, {
      baseURL: process.env.REACT_APP_API_BASE,
      headers: {
        "X-Origin": ORIGIN,
      },
    });
  },
  async getBodyHtml() {
    return await fetch(_raw)
      .then((r) => r.text())
      .then((text) => {
        return text;
      });
  },
};
